// src/pages/register.js
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/styles.css';

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const API_BASE = process.env.REACT_APP_API_URL || '';

export default function Register({ setUser }) {
  const navigate = useNavigate();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  useEffect(() => {
    if (localStorage.getItem('currentUser')) {
      navigate('/');
    }
  }, [navigate]);

  function getCaptchaToken(action) {
    return new Promise((resolve, reject) => {
      if (!window.grecaptcha?.enterprise) {
        reject(new Error('reCAPTCHA no está cargado'));
        return;
      }
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise
          .execute(SITE_KEY, { action })
          .then(resolve)
          .catch(reject);
      });
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirm) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);
    try {
      let user;

      if (API_BASE) {
        // Backend disponible: validar reCAPTCHA y registrar via API
        const captchaToken = await getCaptchaToken('REGISTER');
        const resp = await fetch(`${API_BASE}/api/register`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, password, captchaToken })
        });
        const data = await resp.json();
        if (!resp.ok) throw new Error(data.message || 'Error al registrar.');
        user = data.user;
      } else {
        // Sin backend: registrar directamente en localStorage
        const users = JSON.parse(localStorage.getItem('users') || '[]');
        if (users.find(u => u.email === email)) {
          throw new Error('El correo ya está registrado.');
        }
        user = { email, role: 'user' };
        users.push({ email, password, role: 'user' });
        localStorage.setItem('users', JSON.stringify(users));
        localStorage.setItem(`favorites_${email}`, JSON.stringify([]));
      }

      localStorage.setItem('currentUser', JSON.stringify(user));
      setUser(user);
      navigate('/');
    } catch (err) {
      console.error('Registro fallido:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Registrarse</h2>
      <form onSubmit={handleSubmit} className="auth-form">
        {error && <p className="error-message">{error}</p>}

        <label htmlFor="email">Correo Electrónico:</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />

        <label htmlFor="password">Contraseña:</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />

        <label htmlFor="confirm">Confirmar Contraseña:</label>
        <input
          id="confirm"
          type="password"
          value={confirm}
          onChange={e => setConfirm(e.target.value)}
          required
        />

        <button type="submit" className="btn-submit" disabled={loading}>
          {loading ? 'Registrando...' : 'Registrarse'}
        </button>

        <p className="recaptcha-notice">
          Este sitio está protegido por reCAPTCHA de Google.
          Se aplican la <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Política de privacidad</a> y los <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">Términos de servicio</a>.
        </p>

        <p style={{ marginTop: '1rem', color: 'var(--color-text-secondary)' }}>
          ¿Ya tienes cuenta? <Link to="/login">Inicia sesión aquí</Link>
        </p>
      </form>
    </div>
  );
}
